import axios, { AxiosResponse } from 'axios';
import { getAccessToken } from './accessToken';
import { URL_LIBRANZAS, LIBRANZAS_APIKEY } from '@/constants/api-constants';

type CargarExcelPayload = {
    fileName: string;
    base64Content: string;
};

export const setCargarExcelLibranzas = (payload: CargarExcelPayload): Promise<AxiosResponse | undefined> =>
    getAccessToken()
        .then((tokenResponse) => {
            const token = tokenResponse?.data.data.id_token;
            return axios.request({
                method: 'post',
                url: `${URL_LIBRANZAS}/consulta-deudores/subir-excel`,
                headers: {
                    apikey: LIBRANZAS_APIKEY,
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: payload,
            });
        })
        .catch((error) => {
            const status = error.response?.status;
            if (status === 400 || status === 500) return error.response;
            console.error(error);
            return undefined;
        });
